var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main-layout',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('section',{staticClass:"authentication authentication-container"},[_c('div',{staticClass:"authentication-container--login_form"},[_vm._t("default")],2)])]},proxy:true}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }